export default __webpack_public_path__ + "icon_pago_seguro.50cd4c.svg";